<template>
	<app-page>
		<app-heading title="Users" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="users"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchUsers"
				>
					<template v-slot:role="{ item }">
						<span>{{ rolesMap[item.role] || 'Not Found' }}</span>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			users: [],
			rolesMap: undefined,
			count: -1,
			refresh: false,
			resetDialog: {
				show: false,
				password: '',
			},
			headers: [{
				text: 'Email',
				value: 'email',
				sortable: true,
			}, {
				text: 'Fist name',
				value: 'firstName',
				sortable: true,
			}, {
				text: 'Last name',
				value: 'lastName',
				sortable: true,
			}, {
				text: 'Role',
				value: 'role',
				sortable: false,
			}, {
				text: '2FA',
				value: 'activeMFA',
				sortable: false,
				cb: item => (item.activeMFA ? 'Yes' : 'No'),
			}],
		}
	},
	methods: {
		async fetchRoles() {
			if (this.rolesMap) { return }

			const request = this.$ravello.request()
				.v(3)
				.to('roles')

			try {
				const roles = await request.dataSource()
				this.rolesMap = roles.reduce((acc, role) => ({ ...acc, [role.value]: role.text }), {})
			} catch (err) {
				this.rolesMap = {}
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async fetchUsers(pagination) {
			await this.fetchRoles()
			const request = this.$ravello.request()
				.v(3)
				.to('users')
				.fromPagination(pagination)

			try {
				this.users = await request.get()
				if (this.count === -1) {
					const countResult = await request.count()
					this.count = countResult.total
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
	},
}
</script>
